import React from 'react';
import './products.css'
import cookie from 'react-cookies';

import Topbar2 from "../../component/topbar2"
import { requestGet_WithOutDecrypt,getAllUrlparameter} from '../../component/functions';
import { Row, Col ,Input, Skeleton, Descriptions,Empty,Modal} from 'antd';

const { Search } = Input;

class Corpus extends React.Component {
  constructor(props) {
    //父组件传入参数
    super(props);
    //当前组件状态
    this.state = {
      mobile:false,

      jwt:"",
      // 搜索框内容
      searchkey:"",
      loading:false,
      requestdone:false,
      notLoggedModal:false,

      // 搜索结果
      result:[],
    }
  };

  componentDidMount() {
    this.setState({
        jwt: cookie.load("jwt_v2"),
    })
    this.deviceCheck();
  }

    deviceCheck = () =>{
      if(getAllUrlparameter()["applet"] === "1"){
        this.setState({
          mobile:true,
          jwt:getAllUrlparameter()['jwt']
        });
      }
    }

    // 输入框内容改变
    changeinput = (e)=>{
      this.setState({
        searchkey:e.target.value
      })
    }

    // 搜索框
    search = (e) =>{
      if(e !== ""){
        if(this.state.jwt !== undefined){
          this.setState({searchkey:e})
          this.requestresult(1)
        }else{
          // alert("请登录后使用！")
          this.setState({notLoggedModal:true})
        }
      }
    }

    // 发起搜索
    requestresult = () =>{
      this.setState({loading:true})
      let url =  `https://gateway1.moxidata.cn/mktcharts/modeldict/?method=cilian&words=${this.state.searchkey}&strcode=${this.state.jwt}`;

      requestGet_WithOutDecrypt(url).then((value)=>{
        if(value.error){
          this.setState({
              loading:false,
              result:value.records,
              requestdone:true,
          })
        }else{
          this.setState({
              loading:false,
              result:[],
              requestdone:true,
          })
        }
      })
    }


    render() {
        if(!this.state.mobile){
            let JSXResultContent = <></>
            if(this.state.loading){
                JSXResultContent=<div style={{backgroundColor:"white",padding:"20px"}}><Skeleton /><Skeleton /></div>
            }else{
                if(this.state.result.length>0){
                    JSXResultContent = <Descriptions title="关联词：相关度" className='corpus-result-body' column={4}>
                            {
                                this.state.result.map((e,i)=>{
                                    // console.log(e[1].toString().slice(0,4))
                                    return <Descriptions.Item label={e[0]} key={e[0]}>{e[1].toString().slice(0,4)}</Descriptions.Item>
                                })
                            }
                        </Descriptions>
                }else{
                    JSXResultContent = <Row className='corpus-result-body' style={{height:"300px"}} align="middle" justify='center'>
                            <Empty description={<div style={{color:"black"}}>暂无数据，换个词试试吧！</div>}/>
                        </Row>
                }
            }

            const JSXNotLoggedModal = 
            <Modal title="未登录" cancelText="关闭" okText="登录/免费注册" visible={this.state.notLoggedModal} onOk={()=>{this.setState({notLoggedModal:false});window.location.href="/forest/login"}} onCancel={()=>{this.setState({notLoggedModal:false})}}>
                <p>本工具完全免费</p>
                <p>请在登录 / 免费注册后使用！</p>
            </Modal>

            return (
                <div style={{minWidth:"1200px"}}>
                    {JSXNotLoggedModal}

                    <Topbar2 pagetitle="文旅词涟"/>
                    <Row className='corpus-funbody'>
                        {/* 搜索框 */}
                        <Row className={!this.state.requestdone?"prodects-search-body prodects-search-body-init":"prodects-search-body prodects-search-body-searched"}>
                            <Search className='prodects-search' placeholder="请输入关键词" size="large" value={this.state.searchkey} onChange={this.changeinput}  onSearch={this.search} loading={this.state.loading} allowClear />
                        </Row>
                        {
                            !this.state.requestdone &&<Row className='products-introduce' justify='center'>
                                <Col span={12}>感受一场文字的蝴蝶风暴，输入文旅词汇，获得“三高”——高相关名词、高频专业术语、高级表达同义词~</Col>
                            </Row>
                        }
                        {/* 搜索结果 */}
                        <div className={!this.state.requestdone?"prodects-result-body prodects-result-body-hide":"prodects-result-body"}>
                            <Row>
                                <div className='model-result-tabs'>
                                    {JSXResultContent}
                                </div>
                            </Row>
                        </div>
                    </Row>
                </div>
            );
        }else{
            let JSXResultContent = <></>
            if(this.state.loading){
                JSXResultContent=<div style={{backgroundColor:"white",padding:"20px"}}><Skeleton /><Skeleton /></div>
            }else{
                if(this.state.result.length>0){
                    JSXResultContent = <Descriptions title="关联词：相关度" className='corpus-result-body' column={3}>
                            {
                                this.state.result.map((e,i)=>{
                                    // console.log(e[1].toString().slice(0,4))
                                    return <Descriptions.Item label={e[0]} key={e[0]}>{e[1].toString().slice(0,4)}</Descriptions.Item>
                                })
                            }
                        </Descriptions>
                }else{
                    JSXResultContent = <Row className='corpus-result-body' style={{height:"300px"}} align="middle" justify='center'>
                            <Empty description={<div style={{color:"black"}}>暂无数据，换个词试试吧！</div>}/>
                        </Row>
                }
            }

            return(
                <div className="mobile-artkey-funbody">
                    <Row justify='center'><Col className='mobile-products-pagetitle'>文语词涟</Col></Row>
                    <Row style={{marginTop:this.state.requestdone?"20px":"30vh",transition:".5s"}}><Search className='mobile-prodects-search' placeholder="请输入关键词" size="large" value={this.state.searchkey} onChange={this.changeinput}  onSearch={this.search} loading={this.state.loading} allowClear /></Row>
                    {!this.state.requestdone &&<Row style={{width:"80%",color:"white",margin:"auto"}}>感受一场文字的蝴蝶风暴，输入文旅词汇，获得“三高”——高相关名词、高频专业术语、高级表达同义词~</Row>}
                    <div className={!this.state.requestdone?"mobile-prodects-result-body prodects-result-body-hide":"mobile-prodects-result-body"}>
                        {this.state.requestdone && JSXResultContent}
                    </div>
                </div>
            )
        }    
    }

}

export default Corpus;